var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notFound)?_c('g-not-found'):_vm._e(),(!_vm.loading)?_c('div',[(!_vm.notFound)?_c('g-user-info',{attrs:{"owner":_vm.owner,"buyer":_vm.buyer,"company":_vm.company},on:{"submit":_vm.toUpdateData}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }